import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import ar from "./ar";
import en from "./en";

const DICTS = { ar, en };
const I18nContext = createContext(null);

const lookup = (dict, key) => key.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("bay_lang") || "ar");
  const dir = lang === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    localStorage.setItem("bay_lang", lang);
  }, [lang, dir]);

  const t = useCallback((key, vars) => {
    let v = lookup(DICTS[lang], key);
    if (v === undefined) v = lookup(DICTS.ar, key);
    if (v === undefined) return typeof vars === "string" ? vars : key;
    if (typeof v === "string" && vars && typeof vars === "object") {
      Object.entries(vars).forEach(([k, val]) => { v = v.replace(`{${k}}`, val); });
    }
    return v;
  }, [lang]);

  const nm = useCallback((o) => (o ? (lang === "ar" ? o.name_ar : o.name_en || o.name_ar) : ""), [lang]);
  const toggle = useCallback(() => setLang((l) => (l === "ar" ? "en" : "ar")), []);
  const value = useMemo(() => ({ lang, dir, t, nm, toggle, setLang }), [lang, dir, t, nm, toggle]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
